import { useTheme } from '../contexts/ThemeContext';

const SkeletonLoader = () => {
  const { theme } = useTheme();

  return (
    <div className={`fixed inset-0 z-50 min-h-screen ${
      theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'
    }`}>
      {/* Navbar Skeleton */}
      <div className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-sm ${
        theme === 'light' ? 'bg-white/90' : 'bg-gray-800/50'
      }`}>
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-2">
              <div className={`w-8 h-8 rounded shimmer-animation ${
                theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
              }`}></div>
              <div className={`w-48 h-6 rounded shimmer-animation ${
                theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
              }`}></div>
            </div>
            <div className="hidden md:block">
              <div className="flex space-x-4">
                <div className={`w-16 h-8 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-16 h-8 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-16 h-8 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-16 h-8 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ApnaEduHub Page Skeleton */}
      <section className="pt-24 pb-16 lg:pt-32 lg:pb-20">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className={`w-32 h-8 mb-8 rounded shimmer-animation ${
            theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
          }`}></div>
          <div className="grid items-center grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <div className={`w-16 h-16 rounded-full shimmer-animation lg:w-20 lg:h-20 ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className="space-y-2">
                  <div className={`w-48 h-8 rounded shimmer-animation lg:w-64 lg:h-10 ${
                    theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                  }`}></div>
                  <div className={`w-32 h-6 rounded shimmer-animation lg:w-40 ${
                    theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                  }`}></div>
                </div>
              </div>
              <div className="space-y-3">
                <div className={`w-full h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-full h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-3/4 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className={`h-20 rounded-xl shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-20 rounded-xl shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-20 rounded-xl shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-20 rounded-xl shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
            </div>
            <div className={`h-64 rounded-2xl shimmer-animation lg:h-80 ${
              theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
            }`}></div>
          </div>
        </div>
      </section>

      {/* Content Sections Skeleton */}
      <div className="py-16 space-y-16">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className={`w-64 h-8 mx-auto mb-8 rounded shimmer-animation ${
            theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
          }`}></div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <div className={`h-64 rounded-xl shimmer-animation ${
              theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
            }`}></div>
            <div className={`h-64 rounded-xl shimmer-animation ${
              theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
            }`}></div>
            <div className={`h-64 rounded-xl shimmer-animation ${
              theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
            }`}></div>
          </div>
        </div>
        
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className={`w-48 h-8 mx-auto mb-8 rounded shimmer-animation ${
            theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
          }`}></div>
          <div className={`h-64 rounded-xl shimmer-animation ${
            theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
          }`}></div>
        </div>
      </div>

      {/* Footer Skeleton */}
      <div className={`py-8 border-t ${
        theme === 'light' 
          ? 'border-gray-200 bg-gray-50/80' 
          : 'border-gray-800 bg-gray-900/80'
      }`}>
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
            <div className="space-y-4">
              <div className={`w-48 h-6 rounded shimmer-animation ${
                theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
              }`}></div>
              <div className="space-y-2">
                <div className={`w-full h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-3/4 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
            </div>
            <div className="space-y-4">
              <div className={`w-24 h-6 rounded shimmer-animation ${
                theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
              }`}></div>
              <div className="space-y-2">
                <div className={`w-20 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-24 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-4 rounded w-28 shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
            </div>
            <div className="space-y-4">
              <div className={`w-24 h-6 rounded shimmer-animation ${
                theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
              }`}></div>
              <div className="space-y-2">
                <div className={`w-20 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`w-24 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-4 rounded w-28 shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
            </div>
            <div className="space-y-4">
              <div className={`w-24 h-6 rounded shimmer-animation ${
                theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
              }`}></div>
              <div className="space-y-2">
                <div className={`w-32 h-4 rounded shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-4 rounded w-28 shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
                <div className={`h-4 rounded w-36 shimmer-animation ${
                  theme === 'light' ? 'bg-gray-200' : 'bg-gray-700'
                }`}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .shimmer-animation {
          background: linear-gradient(
            90deg,
            ${theme === 'light' ? '#e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%' : '#374151 0%, #4b5563 50%, #374151 100%'}
          );
          background-size: 200% 100%;
          animation: shimmer 2s infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export default SkeletonLoader;
